export const FEATURES = [
  { id: 'challenge', name: 'challenge', description: 'Enable challenge functionality' },
  { id: 'adaptiveTestV2', name: 'adaptiveTestV2', description: 'Enable adaptive test version 2' },
  { id: 'freemium-access', name: 'freemium-access', description: 'Allow freemium access to content' },
{ id: 'payment', name: 'payment', description: 'Enable payment functionality' },
  { id: 'mobicom', name: 'mobicom', description: 'Enable Mobicom carrier billing' },
  { id: 'accessTokenRefresh', name: 'accessTokenRefresh', description: 'Enable access token refresh' },
  { id: 'skills', name: 'skills', description: 'Enable skills functionality' },
  { id: 'no_more_10_min', name: 'no_more_10_min', description: 'Extend JWT expiration beyond 10 minutes' },
  { id: 'new_explore_screen', name: 'new_explore_screen', description: 'Enable new explore screen design' },
  { id: 'streaming', name: 'streaming', description: 'Enable live streaming functionality' },
  { id: 'change_language', name: 'change_language', description: 'Enable language changing functionality' },
  { id: 'commenting', name: 'commenting', description: 'Enable commenting on content' },
  { id: 'guided_journey_program', name: 'guided_journey_program', description: 'Enable guided journey programs' },
  { id: 'class', name: 'class', description: 'Enable class functionality' },
  { id: 'freeTrial', name: 'freeTrial', description: 'Enable free trial access' },
  { id: 'unitel_carrier_billing', name: 'unitel_carrier_billing', description: 'Enable Unitel carrier billing' },
  { id: 'unitel_free_trial', name: 'unitel_free_trial', description: 'Enable Unitel free trial for all users' },
];

// Features that support global management (as per API documentation)
export const GLOBAL_MANAGEABLE_FEATURES = [
  'freemium-access',
  'payment', 
  'mobicom',
  'accessTokenRefresh',
  'no_more_10_min',
  'unitel_carrier_billing',
  'unitel_free_trial'
];
